/**
 * React Query hook for a single config version's detail (snapshot + diff).
 *
 * Powers the read-only "Détails" inspect modal on the history table:
 * `GET /config/versions/{id}` returns the version's stored snapshot plus a
 * field-level diff of that version against the current live value.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  configVersioningService,
  type VersionDetail,
} from '../../api/configVersioningService';
import { configVersioningKeys } from './queryKeys';

/**
 * Fetch a version's detail. Disabled while `versionId` is empty so the query
 * only fires once a row has been selected for inspection.
 */
export function useConfigVersion(
  versionId: string | null,
): UseQueryResult<VersionDetail> {
  return useQuery<VersionDetail>({
    queryKey: configVersioningKeys.version(versionId ?? ''),
    queryFn: () => configVersioningService.fetchVersion(versionId as string),
    enabled: Boolean(versionId),
  });
}
